import { EmployerMyTalentComponentLazy } from "../../lazy";
import { EmployerDashboardLayout } from "../layout";

import styles from "./style.module.scss";

export const EmployerDashboardMyTalentPage = () => {
  return (
    <EmployerDashboardLayout
      pageTitle="My Talent"
      bgcolor="var(--soft-violet)"
      setBgOnBody
      contentClassName={styles.page}
    >
      <EmployerMyTalentComponentLazy />
    </EmployerDashboardLayout>
  );
};
